import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';
import {
	BillingBusinessType,
	BillingBusinessTypeIds,
} from '@models/billingBusiness';

@Injectable({
	providedIn: 'root',
})
export class BillingBusinessSubTypesRepoService extends Repo<
	BillingBusinessType,
	BillingBusinessTypeIds
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId: string;

	override GetCollectionPath(pathParams: BillingBusinessTypeIds): string {
		return CollectionPaths.billingBusiness_types_subTypes(
			this.businessId,
			pathParams,
		);
	}

	constructor(firestore: AngularFirestore) {
		super(firestore);
	}
}
